import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '../base';

@Injectable()
export class ProfileService extends ApiService {
  profile(): Observable<any> {
    return this.get(`/platform/api/profiles`);
  }

  changePassword(request: any): Observable<any> {
    return this.post('/platform/api/profiles/change-password', request);
  }
}
